<template>
  <div>
    <panel>
      <div slot="toolbar">
        <w-button class="btn-light float-right" text="Wybierz filtry" @click="openFiltersModal" />
      </div>

      <w-table
        v-if="count !== undefined"
        id-key="documentId"
        :data="list"
        :foot-data="footData"
        :columns="columns"
        :total="count"
        :show-column-numbers="true"
        :hide-search-input="true"
        :hide-add-button="true"
        :per-page="-1"
        @view="goToDetails"
      />

      <div slot="footer" class="float-right">
        <div>
          <post-form
            text="Pobierz CSV"
            class="btn-light mr-2"
            icon="fas fa-download mr-2"
            :url="csvUrl"
            :fields="renderFields"
            :disabled="!count"
          />
        </div>
      </div>
    </panel>

    <filters-modal
      title="Wybierz filtry"
      class="modal-big"
      :filters="filters"
      :show="showFiltersModal"
      @close="closeFiltersModal"
      @save="saveFilters"
    />
  </div>
</template>

<script>
import { setPath } from '@witkac/utils/setPath';
import { mapState } from 'vuex';

import Panel from '@/components/panel/Panel';
import PostForm from '@/components/postForm/PostForm';
import WTable from '@/components/table/Table';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { Storage } from '@/enums/storage.enum';
import { notificationsMixin } from '@/mixins/notifications';
import { reportFiltersMixin } from '@/mixins/reportFilters';
import { config } from '@/utils/config';
import { getPath } from '@/utils/getPath';
import { getFinancialReport, getFinancialReportParams } from '@/utils/report';
import { serverError } from '@/utils/serverError';

// @vuese
// Lista wszystkich dokumentów do raportów
// @group Reports
export default {
  components: { Panel, PostForm, WTable },

  mixins: [
    notificationsMixin,
    reportFiltersMixin({
      settingName: PublicSettings.FINANCIAL_REPORT_AVAILABLE_FILTERS,
      storageKey: Storage.REPORT_FINANCIAL_FILTERS
    })
  ],

  data() {
    return {
      csvUrl: config.csvURL + '/financial-report'
    };
  },

  computed: {
    ...mapState({
      list: state => state.documentIndex.financialReport,
      columns: state => JSON.parse(state.setting.settings[PublicSettings.FINANCIAL_REPORT_COLUMNS].value),
      renderFields(state) {
        this.filters; // odświeżenie po zmianie filtrów
        const params = getFinancialReportParams(this.$route);
        return Object.keys(params).map(name => ({ name, value: params[name] }));
      }
    }),
    count() {
      return this.list.length;
    },
    footData() {
      const footData = {};
      this.columns.forEach(column => {
        if (column.isSumRow && column.calcSumRow !== false) {
          const value = this.list.reduce((all, element) => {
            const val = getPath(element, column.name);
            if (!!val) {
              return all + val;
            }
            return all;
          }, 0);
          setPath(footData, value, column.name);
        }
      });
      footData.documentId = '<b>Razem:</b>';
      return footData;
    }
  },
  methods: {
    // @vuese
    // Przenosi do szczegółów wniosku
    goToDetails(document) {
      this.$router.push({
        name: 'documentView',
        params: { documentId: document.documentId, procedureId: document.procedureId }
      });
    },

    updateList() {
      getFinancialReport(this.$route).catch(err => this.notifyError(serverError(err)));
    }
  }
};
</script>
